import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button } from '../index';
import { colors } from '../../assets/colors';
import { IInvoice } from '../../interfaces';

type InvoiceDownloadProps = {
    invoice: IInvoice;
};

const DownloadContainer = styled.div`
    margin: 20px 0;
    padding: 16px;
    background-color: ${colors.whiteSmoke};
    border-radius: 12px;
    border: 1px solid ${colors.grey};
`;

const DownloadTitle = styled.h3`
    margin: 0 0 12px 0;
    color: ${colors.dark};
    font-size: 16px;
    font-weight: 600;
`;

const DownloadDescription = styled.p`
    margin: 0 0 16px 0;
    color: ${colors.dark2};
    font-size: 14px;
    line-height: 1.4;
`;

const InvoiceDownload = ({ invoice }: InvoiceDownloadProps) => {
    const { t } = useTranslation();

    const handleDownload: Dispatch<SetStateAction<unknown>> = () => {
        if (invoice.download_pdf_url) {
            // Since backend sends Content-Disposition: attachment, use simple approach
            const link = document.createElement('a');
            link.href = invoice.download_pdf_url;
            link.download = `invoice_${invoice.invoice_number || invoice.uuid}.pdf`;
            link.style.display = 'none';

            // Trigger download without opening new tab
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    // Only show download section if download_pdf_url is available
    if (!invoice.download_pdf_url) {
        return null;
    }

    return (
        <DownloadContainer>
            <DownloadTitle>{t('downloadInvoice')}</DownloadTitle>
            <DownloadDescription>
                {t('downloadInvoiceDescription')}
            </DownloadDescription>
            <Button
                i={t('downloadPdf')}
                color={colors.white}
                fontWeight="bold"
                onClick={handleDownload}
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            />
        </DownloadContainer>
    );
};

export default InvoiceDownload; 